import graphql__ffd25154c820b5f0412f from "./__generated__/AnswerEmailWithConsents_answer.graphql.js";import { graphql, useFragment } from "react-relay";

import EmailWithConsentsField from "../Form/Field/EmailWithConsentsField";

const AnswerEmailWithConsents = props => {
  const { content, consentGiven, formField } = useFragment(
    AnswerEmailWithConsents_answer,
    props.answer
  );
  const {
    fieldName,
    label,
    required,
    hint,
    hintPosition,
    displayEmailConsent,
    consentLabel,
    hide
  } = formField;
  const { parent } = props;

  return (
    <EmailWithConsentsField
      fieldName={fieldName}
      label={label}
      required={required}
      hint={hint}
      hintPosition={hintPosition}
      hide={hide}
      parent={parent}
      displayEmailConsent={displayEmailConsent}
      consentLabel={consentLabel}
      defaultValue={content}
      defaultConsentGiven={consentGiven}
    />
  );
};

const AnswerEmailWithConsents_answer = graphql__ffd25154c820b5f0412f;

export default AnswerEmailWithConsents;
